jQuery.event.special.scrolldelta = {
    delegateType: "scroll",
    bindType: "scroll",
    handle: function (event) {
        var handleObj = event.handleObj;
        var targetData = jQuery.data(event.target);
        var ret = null;
        var elem = event.target;
        var isDoc = elem === document;
        var oldTop = targetData.top || 0;
        var oldLeft = targetData.left || 0;
        targetData.top = isDoc ? elem.documentElement.scrollTop + elem.body.scrollTop : elem.scrollTop;
        targetData.left = isDoc ? elem.documentElement.scrollLeft + elem.body.scrollLeft : elem.scrollLeft;
        event.scrollTopDelta = targetData.top - oldTop;
        event.scrollTop = targetData.top;
        event.scrollLeftDelta = targetData.left - oldLeft;
        event.scrollLeft = targetData.left;
        event.type = handleObj.origType;
        ret = handleObj.handler.apply(this, arguments);
        event.type = handleObj.type;
        return ret;
    }
};

$(document).on('ready load scrolldelta', function (e) {
    var scroll_start = $(this).scrollTop();
    var topDelta = e.scrollTopDelta;

    if (scroll_start > 200 ) {
        if (topDelta < 0) {
            $('.bor_head .blog_head_second_bar').slideDown(200);
        } else {
            $('.bor_head .blog_head_second_bar').slideUp(200);
        }
    } else {
        $('.bor_head .blog_head_second_bar').slideDown(200);
    }

    if (scroll_start > 200) {
        $('.bor_head').addClass('scrolled');
    } else {
        $('.bor_head').removeClass('scrolled');
    }
});

$(document).on('click', '.js-close-off-canvas', function(e) {
    e.preventDefault();
    $('#off-canvas').foundation('close');
});
